"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EInput = void 0;
var EInput;
(function (EInput) {
    EInput["TEXT"] = "TEXT";
    EInput["NUMBER"] = "NUMBER";
    EInput["EMAIL"] = "EMAIL";
    EInput["CPF"] = "CPF";
    EInput["CNPJ"] = "CNPJ";
    EInput["AREA"] = "AREA";
    EInput["PHONE"] = "PHONE";
    EInput["DATE"] = "DATE";
    EInput["PASSWORD"] = "PASSWORD";
})(EInput || (exports.EInput = EInput = {}));
